<template>
    <NuxtLink :to="item.route">
        <Motion
            as="button"
            :animate="state"
            :custom="index"
            :initial="false"
            :transition="SidebarUserProfileMotion.ItemTransition"
            :variants="SidebarProfileItemVariants"
            :class="ui.menuItem()">
            <div :style="{ background: item.iconBackgroundColor }" :class="ui.menuIconWrap()">
                <Icon :name="item.icon" :style="{ color: item.iconColor }" size="14" />
            </div>
            <span>{{ item.label }}</span>
        </Motion>
    </NuxtLink>
</template>

<script lang="ts" setup>
    import type { Variant } from 'motion-v';

    import { SidebarUserProfileMotion } from '@constants/motion';
    import { Opacity } from '@constants/motion/defaults';
    import type { SidebarUserProfileNavigationItem } from '@constants/navigation-items';
    import { UIState, type UIStateType } from '@/constants/ui/ui-state';
    import { getSidebarItemMotionDelay } from '@/utils/motion';

    const SidebarProfileItemVariants = Object.freeze({
        [UIState.Collapsed]: { opacity: Opacity.Hidden, x: -8 },
        [UIState.Expanded]: (custom: unknown) => ({
            opacity: Opacity.Visible,
            x: 0,
            transition: {
                ...SidebarUserProfileMotion.ItemTransition,
                delay: getSidebarItemMotionDelay(custom)
            }
        })
    } satisfies Record<UIStateType, Variant>);

    defineProps({
        item: {
            type: Object as PropType<SidebarUserProfileNavigationItem>,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        state: {
            type: String as PropType<UIStateType>,
            required: true
        }
    });

    const ui = useComponentUi('sidebarUserProfileMenuItem');
</script>
